import { PageDefaultContainer, PageDefaultContainerProps } from "@sis/react-library"
import { PropsWithChildren } from "react"
import { PagelInformation } from "./PagelInformation"

interface PageContainerProps {
    pageInfo?: React.ReactNode;
    wrapRightElementForMobile?: boolean;
}

export const PageContainer = ({
    children, heading, pageInfo, wrapRightElementForMobile, ...props
}: PropsWithChildren<PageDefaultContainerProps & PageContainerProps>) => {
    return (
        <PageDefaultContainer
            //noHeader  -  Uncomment if you don't wish to create a header
            heading={heading}
            {...props}
            // background="linear-gradient(to bottom right, blue, rgb(10, 10, 10))" // You can set the background colour
            // color="white" // You can set the default colour
            // headerBackground="linear-gradient(to bottom right, red, rgb(10, 10, 10))"  // You can set the header background colour
            // headerColor="white"  // You can set the header colour
            rightElement={
                pageInfo ?
                    <PagelInformation
                        heading={heading!}
                        pageInfo={pageInfo}
                        wrapRightElementForMobile={wrapRightElementForMobile}
                    /> :
                    undefined
            }
            wrapRightElementForMobile={wrapRightElementForMobile}
        >
            <title>{`SIS Samples: ${heading?.replace('Samples', '')}`}</title>
            {children}
        </PageDefaultContainer >
    )
}